<template>
  <div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        :hide-required-asterisk="false"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="add-box dis-flex">
          <div>
            <div class="title">名称</div>
            <el-form-item label="套餐名称" prop="name">
              <el-input
                :placeholder="rules.name[0].message"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
			<div class="title">级别</div>
            <el-form-item label="2A数量" prop="grade_0">
              <el-input
				type="number"
                :placeholder="rules.grade_0[0].message"
                v-model="ruleForm.grade_0"
              ></el-input>
            </el-form-item>
			<el-form-item label="3A数量" prop="grade_1">
			  <el-input
				type="number"
			    :placeholder="rules.grade_1[0].message"
			    v-model="ruleForm.grade_1"
			  ></el-input>
			</el-form-item>
			<el-form-item label="4A数量" prop="grade_2">
			  <el-input
				type="number"
			    :placeholder="rules.grade_2[0].message"
			    v-model="ruleForm.grade_2"
			  ></el-input>
			</el-form-item>
			<el-form-item label="5A数量" prop="grade_3">
			  <el-input
				type="number"
			    :placeholder="rules.grade_3[0].message"
			    v-model="ruleForm.grade_3"
			  ></el-input>
			</el-form-item>
			<el-form-item label="T数量" prop="grade_4">
			  <el-input
				type="number"
			    :placeholder="rules.grade_4[0].message"
			    v-model="ruleForm.grade_4"
			  ></el-input>
			</el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="row1">
      <div>
        <el-button
          @click="submitForm('ruleForm')"
          class="row-btn add"
          type="primary"
          size="small"
          >{{type == 1?'提交':'修改'}}</el-button>
        <el-button
          @click="back"
          class="row-btn add back"
          type="primary"
          size="small"
          >返回</el-button
        >
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	type:'',//1为添加，2为修改
	options:[],
	options2:[],
      ruleForm: {
        name: "",
        grade_0: 0,
		grade_1: 0,
		grade_2: 0,
		grade_3: 0,
		grade_4: 0,
		
      },
      rules: {
        name: [
          { required: true, message: "请输入套餐名称", trigger: ["blur","change"] },
        ],
        grade_0: [
          { required: true, message: "请输入2A数量", trigger: ["blur","change"] },
        ],
		grade_1: [
		  { required: true, message: "请输入3A数量", trigger: ["blur","change"] },
		],
		grade_2: [
		  { required: true, message: "请输入4A数量", trigger: ["blur","change"] },
		],
		grade_3: [
		  { required: true, message: "请输入5A数量", trigger: ["blur","change"] },
		],
		grade_4: [
		  { required: true, message: "请输入T数量", trigger: ["blur","change"] },
		],
      },
    };
  },
  created() {
	this.type = this.$route.query.type //1为添加，2为修改
	if(this.$route.query.type == 2){
		for(let key in this.ruleForm){
			this.ruleForm[key] = this.$route.query[key]
		}
		this.ruleForm.id = this.$route.query.id
	}
  },
  methods: {
	  // 返回
	  back(){
	    this.$router.go(-1)
	  },
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			//1为添加，2为修改
          if(this.type == 1){
			  this.$api2.advertiseGradegroupAdd(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						this.$router.push({ path: "/sys_setMeal_index"});
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }else if(this.type == 2){
			  this.$api2.advertiseGradegroupEdit(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						this.$router.push({ path: "/sys_setMeal_index"});
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.row1 {
  padding-top: 20px;
  .add {
    padding: 12px 35px;
  }
  .back{
    background-color: #fff;
    color: gray;
    border: 1px solid #DCDFE6;
  }
}
.add-box /deep/ {
  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .el-input {
    width: 300px;
  }
  .el-form-item {
    padding-left: 0 !important;
  }
  .el-form-item__content {
    margin-left: 75px !important;
  }
  .el-form-item__label {
    height: 30px;
    width: 60px !important;
    text-align: justify;
  }
  .el-form-item__label:after {
    display: inline-block;
    content: "";
    padding-left: 100%;
  }
  .el-form-item {
    padding: 10px 30px;
  }
}
/* 去除验证的红色星号 */
.dis-flex
  /deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: " ";
  width: 0px;
  margin-right: 0px;
}
</style>>
